/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type VideoPageEventType = (typeof VideoPageEventType)[keyof typeof VideoPageEventType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoPageEventType = {
  PAGE_VIEW: 'PAGE_VIEW',
  VIDEO_PLAY: 'VIDEO_PLAY',
  VIDEO_END: 'VIDEO_END',
  VIDEO_PROGRESS: 'VIDEO_PROGRESS',
  CTA_CLICK: 'CTA_CLICK',
  PAGE_LEAVE: 'PAGE_LEAVE',
} as const
